export enum ApiEndpoint {
  VERIFY = 'verify',
  SORTING = 'sorting',
  DEFAULT = 'default',
  LOG = 'log',
  WHITELIST = 'whitelist',
  CUSTOM = 'custom',
  DEPLOY = 'deploy',
  CLEAR = 'clear',
  CONFIGURATION = 'configuration',
}

export enum DashboardEndpoint {
  QPS = 'qps',
  REQUEST_PER_IP = 'request_per_ip',
  TOP_TEN_URL = 'top_ten_url',
  ATTACK_COUNT = 'attack_count',
  CACHE = 'cache',
  TOTAL_TRAFFIC = 'total_traffic',
  TRAFFIC_LOG = 'traffic_log',
  ERROR_LOG = 'error_log',
  ATTACK_LOG = 'attack_log',
  WAF_LOG = 'waf_log',
}

export enum WorkspaceMemberEndpoint {
  JOIN = 'join',
  MEMBER = 'member',
  TRANSFER = 'transfer',
  RESEND_INVITATION = 'resend_invitation',
  ACCEPT = 'accept',
}

export enum UserEndpoint {
  REGISTER = 'register',
  VERIFY_EMAIL = 'verify_email',
  REVERIFY_EMAIL = 'reverify_email',
  FORGOT_PASSWORD = 'forgot_password',
  RESET_PASSWORD = 'reset_password',
  VERIFY_NEW_PASSWORD = 'verify_new_password',
}

export enum OriginEndpoint {
  HEALTH_CHECK = 'health_check',
  HEALTH_CHECK_STATUS = 'health_check_status',
}
